import { useTranslation } from "react-i18next";

export interface SessionExpiredDialogI18n {
  title: string;
  lead: string;
  blockedLead: string;
  failedLead: string;
  signIn: string;
  tryAgain: string;
  signingIn: string;
}

export const useSessionExpiredDialogI18n = (): SessionExpiredDialogI18n => {
  const { t } = useTranslation();
  return {
    title: t("auth.sessionExpired.title", "Sign in to keep going"),
    lead: t(
      "auth.sessionExpired.lead",
      "Your session has expired. Sign in again in a new window. This page stays as it is, and your changes are saved once you're back.",
    ),
    blockedLead: t(
      "auth.sessionExpired.blockedLead",
      "Your browser blocked the sign-in window. Allow pop-ups for this site, then try again.",
    ),
    failedLead: t(
      "auth.sessionExpired.failedLead",
      "Sign-in didn't complete. Your changes are still waiting. Give it another go.",
    ),
    signIn: t("auth.sessionExpired.signIn", "Sign in"),
    tryAgain: t("auth.sessionExpired.tryAgain", "Try again"),
    signingIn: t("auth.sessionExpired.signingIn", "Signing in..."),
  };
};
